const state = {
  dynamicDetails: {}// 动态详情
}
const mutations = {
  setDetailsVueX: (state, option) => {
    state[option.state] = option.data
  }
}
const actions = {
  SaveDynamicDetails({ commit }, data) {
    commit('setDetailsVueX', {
      state: 'dynamicDetails',
      data: data
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
